module.exports = __webpack_public_path__ + "img/logo-new-year.d0587848.svg";